import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import gsap from 'gsap';

const CreateUpdateSubPage = ({setShowCreatePage, containerRef, subPageId, setSubPageId, subPageName, setSubPageName, selectedPage, setSelectedPage, fetchSubpages, pages}) => {
    const [errors, setErrors] = useState({});
  
  
    const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!selectedPage) errors.selectedPage = 'select page';
    if (!subPageName.trim()) errors.subPageName = 'subpage name cannot be empty';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    const formData = new FormData();
    formData.append('page_id', selectedPage);
    formData.append('subpage', subPageName);

    try {

      if (subPageId) {
        const response = await api.post(`/subpageapi/update/${subPageId}`, formData);
        if (response.data.status === "success") {
          toast.success('Subpage updated successfully!');
          setSubPageId(null);
          handleCancel();

        } else {
          toast.error('Failed to update subpage');
        }
      } else {
        const response = await api.post('/subpageapi/add', formData);

        if (response.data.status === "success") {
          toast.success(`Subpage created successfully!`);
        } else {
          toast.error('Failed to create subpage');
        }
      }
      setSelectedPage('');
      setSubPageName('');
      handleCancel();
      fetchSubpages();
    } catch (error) {
      console.error('Error saving subpage:', error);
      toast.error('Error saving subpage');
    }
  };

  function handleCancel(){
     if (containerRef.current) {
        gsap.to(containerRef.current, {
            autoAlpha: 0,
            y: 50,
            duration: 0.4,
            ease: "power2.in",
            onComplete: () =>    setShowCreatePage(false),
        });
        } else {
            setShowCreatePage(false);
        }
  }


  return (
    <div className='floating-form-container smaller' ref={containerRef} >
      <div className="heading">
        <h2>Page Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor='vendor'>Select Page *</label>
                        <select className={`form-control ${errors.selectedPage ? 'is-invalid' : ''}`} value={selectedPage} onChange={(e) => setSelectedPage(e.target.value)}>
                      <option value=''>Select Page</option>
                      {pages.map(page => (
                        <option key={page.id} value={page.id}>{page.name}</option>
                      ))}
                    </select>
                    <b>{errors.selectedPage && <div className='text-danger small'>{errors.selectedPage}</div>}</b>
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor='vendor'>Subpage Name *</label>
                        <input type='text' className={`form-control ${errors.subPageName ? 'is-invalid' : ''}`} value={subPageName} onChange={(e) => setSubPageName(e.target.value)} />
                    <b>{errors.subPageName && <div className='text-danger small'>{errors.subPageName}</div>}</b>
                    </div>

                </div>


            </div>

            <div className="form-btn-container">

                <button type='submit'>{subPageId ? 'Update' : 'Create'}</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default CreateUpdateSubPage;
